import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ProgressBar } from './Step1';

export default function OnboardingStep2() {
  const [volume, setVolume] = useState(500);
  const [agents, setAgents] = useState(1);
  const [schedule, setSchedule] = useState('24/7');
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4 py-20">
      <div className="w-full max-w-2xl">
        <ProgressBar step={2} />
        <h1 data-testid="onboarding-step2-title" className="text-2xl md:text-3xl font-bold text-white font-mono mb-2 section-marker">Estimate your workload</h1>
        <p className="text-zinc-500 text-sm mb-8">This helps us recommend the right hardware tier.</p>

        <div className="space-y-8 mb-8">
          <div className="bg-[#0A0A0A] border border-zinc-800 rounded-sm p-6">
            <label className="block text-sm font-mono text-zinc-300 mb-4">Expected messages per day</label>
            <input data-testid="onboarding-volume-slider" type="range" min="100" max="10000" step="100" value={volume} onChange={e => setVolume(e.target.value)}
              className="w-full h-1 bg-zinc-800 rounded-full appearance-none cursor-pointer [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:bg-emerald-500 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:cursor-pointer" />
            <div className="flex justify-between mt-2">
              <span className="text-xs font-mono text-zinc-600">100</span>
              <span className="text-sm font-mono text-emerald-400">{Number(volume).toLocaleString()} msgs/day</span>
              <span className="text-xs font-mono text-zinc-600">10,000</span>
            </div>
          </div>

          <div className="bg-[#0A0A0A] border border-zinc-800 rounded-sm p-6">
            <label className="block text-sm font-mono text-zinc-300 mb-4">Number of agents</label>
            <div className="flex gap-3">
              {[1, 2, 5, 10, 20].map(n => (
                <button key={n} data-testid={`onboarding-agents-${n}`} onClick={() => setAgents(n)}
                  className={`px-4 py-2 rounded-sm font-mono text-sm transition-all ${agents === n ? 'bg-emerald-500/10 text-emerald-400 border border-emerald-500/30' : 'border border-zinc-800 text-zinc-500 hover:border-zinc-700'}`}>
                  {n}
                </button>
              ))}
            </div>
          </div>

          <div className="bg-[#0A0A0A] border border-zinc-800 rounded-sm p-6">
            <label className="block text-sm font-mono text-zinc-300 mb-4">Usage schedule</label>
            <div className="flex gap-3">
              {['24/7', 'Business Hours', 'Custom'].map(s => (
                <button key={s} data-testid={`onboarding-schedule-${s.toLowerCase().replace(/\s|\//g, '-')}`} onClick={() => setSchedule(s)}
                  className={`px-4 py-2 rounded-sm font-mono text-sm transition-all ${schedule === s ? 'bg-emerald-500/10 text-emerald-400 border border-emerald-500/30' : 'border border-zinc-800 text-zinc-500 hover:border-zinc-700'}`}>
                  {s}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="flex items-center justify-between">
          <button data-testid="onboarding-back-2" onClick={() => navigate('/onboarding/step-1')} className="text-sm font-mono text-zinc-500 hover:text-zinc-300 transition-colors">Back</button>
          <button data-testid="onboarding-next-2" onClick={() => navigate('/onboarding/step-3')} className="bg-emerald-500 text-black font-mono font-bold text-sm rounded-sm px-8 py-3 hover:bg-emerald-400 transition-all click-scale shadow-[0_0_15px_rgba(16,185,129,0.3)]">
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
